import { HttpBadStatusCodeError } from '@cian/peperrors/shared';

import { TThunkAction } from '../../types/redux';
import { TAddTemporarilyResponse } from '../../common/repositories/encrypted-file-manager/v2/add-temporarily';
import { setErrors, setFileUploadingProgress, setInputsState, setIsFileUploading } from './actions';
import { IMapper200, mapper200 } from './mappers';
import { IDocumentFile } from '../../common/repositories/job-vacancies-backend/entities/file/DocumentFile';
import { uploadFile } from '../../services/uploadFile';
import { progressFromEvent } from '../../utils/progressFromEvent';

const onUploadingProgress: TThunkAction<(event: ProgressEvent<XMLHttpRequestEventTarget>) => void> =
  dispatch =>
  (event: ProgressEvent<XMLHttpRequestEventTarget>): void => {
    const percentComplete = progressFromEvent(event);

    dispatch(setFileUploadingProgress(percentComplete));
  };

export const uploadTemporaryFile =
  (file: File): TThunkAction<Promise<boolean>> =>
  async (dispatch, getState, context) => {
    const { logger, config } = context;

    dispatch(setFileUploadingProgress(0));
    dispatch(setIsFileUploading(true));

    try {
      const { response, statusCode }: TAddTemporarilyResponse | IMapper200 = await uploadFile({
        config,
        parameters: {
          file,
        },
        mappers: {
          200: mapper200,
        },
        onProgress: dispatch(onUploadingProgress),
      });

      if (statusCode === 200) {
        dispatch(setFileUploadingProgress(100));
        dispatch(setIsFileUploading(false));
        dispatch(
          setInputsState({
            cvFile: response as IDocumentFile,
          }),
        );

        return true;
      }

      throw new HttpBadStatusCodeError('Не удалось загрузить файл', Number(statusCode), 'uploadFile');
    } catch (e) {
      dispatch(setIsFileUploading(false));
      dispatch(setErrors({ cvFile: e.message }));

      logger.error(e, { domain: 'uploadFile' });

      return false;
    }
  };
